import React from 'react';
import { useI18n, useLicenses } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { FC } from 'react';
import PrinterSettings from '~Scenes/Settings-v2/Scenes/Printers';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import LicenseIcon from '~Assets/icons/license.svg';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import styled from '@emotion/styled';

const HandyWrapper = styled(Box)`
  width: 100vw;
  max-width: 320px;
  height: 100%;
  margin: auto;
  background: var(--colorBlueGray1200);
  position: relative;
`;

const HandyPrinters: FC = () => {
  const { i18n } = useI18n();
  const licenses = useLicenses();

  const hasLicense = licenses.hasHandheldPro || licenses.hasHandheldOrder;

  return (
    <HandyPageWrapper>
      <div>
        {hasLicense ? (
          <PrinterSettings />
        ) : (
          <HandyWrapper>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap="xs"
              justifyContent="center">
              <Icon height="48px" width="48px" src={LicenseIcon} color="var(--colorBlueGray200)" />

              <Heading level={2} color="var(--colorWhite)">
                {i18n('ClaimLicense.LicenseRequired')}
              </Heading>
              <Paragraph style={{ textAlign: 'center' }} level={4} color="var(--colorBlueGray200)">
                {i18n('ClaimLicense.HandheldProOrOrderRequired')}
              </Paragraph>
            </Box>
          </HandyWrapper>
        )}
      </div>
    </HandyPageWrapper>
  );
};

export default HandyPrinters;
